import { ChatContext } from "./ChatContextProvider";

export default ChatContext;
